<app-dashboard-layout [loading]="false" [downloader]="null" [dialog]="false">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <div class="max-w-md mx-auto">
    <h1 class="text-lg font-semibold text-gray-800 mb-4">Fund Wallet</h1>

    <!-- Wallet Type -->
    <div class="mb-4">
      <label class="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Select Wallet Type</label>

      <!-- Skeleton loader -->
      <div *ngIf="loading && fundWalletTypes.length === 0" class="space-y-2">
        <div *ngFor="let _ of [0,1,2]" class="flex items-start gap-2.5 border border-gray-100 rounded-lg px-3 py-3">
          <div class="mt-0.5 shrink-0 w-3.5 h-3.5 rounded-full bg-gray-200 animate-pulse"></div>
          <div class="min-w-0 flex-1 space-y-2">
            <div class="h-3 bg-gray-200 rounded animate-pulse w-3/4"></div>
            <div class="flex gap-2">
              <div class="h-2.5 bg-gray-200 rounded animate-pulse w-1/4"></div>
              <div class="h-2.5 bg-gray-200 rounded animate-pulse w-1/6"></div>
            </div>
          </div>
        </div>
      </div>

      <p *ngIf="!loading && fundWalletTypes.length === 0" class="text-sm text-gray-400 italic">
        No fundable wallet types available.
      </p>

      <div class="space-y-2">
        <div
          *ngFor="let wt of fundWalletTypes"
          (click)="selectWalletType(wt)"
          class="flex items-start gap-2.5 border rounded-lg px-3 py-3 cursor-pointer transition"
          [ngClass]="selectedWalletType?.TranzgateClientId === wt.TranzgateClientId && selectedWalletType?.TranzgatePaymentCode === wt.TranzgatePaymentCode
            ? 'border-primary bg-primary/5'
            : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'"
        >
          <!-- Radio indicator -->
          <div class="mt-0.5 shrink-0 w-3.5 h-3.5 rounded-full bg-primary flex items-center justify-center">
            <div
              class="rounded-full bg-white transition-all duration-150"
              [ngClass]="selectedWalletType?.TranzgateClientId === wt.TranzgateClientId && selectedWalletType?.TranzgatePaymentCode === wt.TranzgatePaymentCode ? 'w-1.5 h-1.5' : 'w-2.5 h-2.5'"
            ></div>
          </div>
          <!-- Content -->
          <div class="min-w-0 flex-1">
            <p
              class="text-sm font-medium leading-snug"
              [ngClass]="selectedWalletType?.TranzgateClientId === wt.TranzgateClientId && selectedWalletType?.TranzgatePaymentCode === wt.TranzgatePaymentCode ? 'text-primary' : 'text-gray-800'"
            >{{ wt.CollectionTypeName }}</p>
            <div class="flex items-center gap-2 mt-0.5 flex-wrap">
              <span *ngIf="wt.CollectionTypeHeaderName" class="text-xs text-gray-400">{{ wt.CollectionTypeHeaderName }}</span>
              <span *ngIf="wt.SuggestedAmount > 0" class="text-xs text-gray-400">&#8358;{{ wt.SuggestedAmount | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Amount -->
    <div *ngIf="selectedWalletType" class="mb-5">
      <label class="block text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Amount</label>
      <div class="border border-gray-200 rounded-lg overflow-hidden focus-within:border-primary transition flex items-center">
        <span class="pl-3 text-sm text-gray-400">&#8358;</span>
        <input
          type="number"
          [(ngModel)]="fundWalletAmount"
          name="fundWalletAmount"
          min="1"
          step="any"
          class="w-full px-2 py-2.5 text-sm text-gray-700 bg-white focus:outline-none"
          placeholder="0.00"
        />
      </div>
      <p *ngIf="selectedWalletType.SuggestedAmount > 0" class="text-xs text-gray-400 mt-1">
        Suggested: &#8358;{{ selectedWalletType.SuggestedAmount | number:'1.2-2' }}
      </p>
    </div>

    <div class="flex gap-3">
      <app-button-primary routerLink="/payments" class="w-1/2" [outline]="true" type="button">
        Back
      </app-button-primary>
      <app-button-primary
        [disabled]="loading || redirecting || !selectedWalletType || !fundWalletAmount"
        (click)="submit()" class="w-1/2" type="button">
        {{ redirecting ? 'Redirecting...' : loading && fundWalletTypes.length === 0 ? 'Loading...' : loading ? 'Please wait...' : 'Proceed to Pay' }}
      </app-button-primary>
    </div>
  </div>
</app-dashboard-layout>
